import type { SixCreated } from '@/services/abstract/CreateSixService';
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { isAPIError } from '@/store/utils';
import { withErrorHandling, withLoader } from '@/store/thunks/thunkWrappers';
import { HTTP_STATUS_CONFLICT } from '@/config/apiConfig';
import type { UpdateSixPayload } from '@/types/create-six.types';

export const updateSixThunk = createAppAsyncThunk<
  SixCreated,
  UpdateSixPayload,
  { rejectValue: { fieldErrors: Record<string, string> } }
>(
  'createSix/updateSixThunk',
  withLoader(
    withErrorHandling(async(payload, thunkAPI) => {
      const { extra, rejectWithValue } = thunkAPI;

      const { id, ownerIds, ...data } = payload;
      const ownerIdsAsStrings = ownerIds.map((owner) => owner.id);

      try {
        return await extra.createSixService.updateSix(id, {
          ...data,
          ownerIds: ownerIdsAsStrings,
        });
      } catch (error) {
        if (isAPIError(error) && error.status === HTTP_STATUS_CONFLICT) {
          return rejectWithValue({ fieldErrors: { name: 'Duplicate name' } });
        }
        throw error;
      }
    })
  )
);
